import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import axios from 'axios';
import { formatPrice } from '../../utils/helpers';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/admin/orders`);
      setOrders(response.data);
    } catch (error) {
      console.error('Error fetching orders:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateOrderStatus = async (orderId, newStatus) => {
    try {
      await axios.put(`${API}/admin/orders/${orderId}/status?status=${newStatus}`);
      fetchOrders();
    } catch (error) {
      console.error('Error updating order status:', error);
      alert('Failed to update order status');
    }
  };

  return (
    <AdminLayout>
      <div>
        <h1 className="text-2xl sm:text-3xl font-serif text-[#3E2723] mb-6 sm:mb-8">Orders</h1>

        <div className="bg-[#FEFCF9]   overflow-hidden">
          {loading ? (
            <div className="p-12 text-center">
              <p className="text-[#C4A265]">Loading orders...</p>
            </div>
          ) : orders.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-[#F5EFE6]">
                  <tr>
                    <th className="text-left py-4 px-6 text-sm font-semibold text-[#3E2723]">Order #</th>
                    <th className="text-left py-4 px-6 text-sm font-semibold text-[#3E2723]">Date</th>
                    <th className="text-left py-4 px-6 text-sm font-semibold text-[#3E2723]">Customer</th>
                    <th className="text-left py-4 px-6 text-sm font-semibold text-[#3E2723]">Items</th>
                    <th className="text-left py-4 px-6 text-sm font-semibold text-[#3E2723]">Amount</th>
                    <th className="text-left py-4 px-6 text-sm font-semibold text-[#3E2723]">Status</th>
                    <th className="text-left py-4 px-6 text-sm font-semibold text-[#3E2723]">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order) => (
                    <tr key={order.id} className="border-b border-[#F5F1E8] hover:bg-[#FDFCFA]">
                      <td className="py-4 px-6 font-medium text-[#3E2723]">{order.order_number}</td>
                      <td className="py-4 px-6 text-sm text-[#5D4E37]">
                        {new Date(order.created_at).toLocaleDateString('en-IN')}
                      </td>
                      <td className="py-4 px-6">
                        <div className="text-sm">
                          <p className="font-medium text-[#3E2723]">{order.shipping_address.name}</p>
                          <p className="text-[#5D4E37]">{order.shipping_address.email}</p>
                        </div>
                      </td>
                      <td className="py-4 px-6 text-sm text-[#5D4E37]">{order.items.length} items</td>
                      <td className="py-4 px-6 text-sm font-semibold text-[#C4A265]">
                        {formatPrice(order.total_amount)}
                      </td>
                      <td className="py-4 px-6">
                        <select
                          value={order.status}
                          onChange={(e) => updateOrderStatus(order.id, e.target.value)}
                          className={`px-3 py-1  text-sm font-semibold border-2 ${
                            order.status === 'paid' ? 'bg-green-50 border-green-200 text-green-700' :
                            order.status === 'shipped' ? 'bg-blue-50 border-blue-200 text-blue-700' :
                            order.status === 'delivered' ? 'bg-purple-50 border-purple-200 text-purple-700' :
                            'bg-yellow-50 border-yellow-200 text-yellow-700'
                          }`}
                        >
                          <option value="pending">Pending</option>
                          <option value="paid">Paid</option>
                          <option value="shipped">Shipped</option>
                          <option value="delivered">Delivered</option>
                          <option value="cancelled">Cancelled</option>
                        </select>
                      </td>
                      <td className="py-4 px-6">
                        <button
                          onClick={() => {
                            const details = `Order: ${order.order_number}\nCustomer: ${order.shipping_address.name}\nEmail: ${order.shipping_address.email}\nPhone: ${order.shipping_address.phone}\n\nAddress:\n${order.shipping_address.address}\n${order.shipping_address.city}, ${order.shipping_address.state} - ${order.shipping_address.pincode}\n\nItems:\n${order.items.map(item => `- ${item.product_name} x ${item.quantity} @ ₹${item.price}`).join('\n')}\n\nTotal: ₹${order.total_amount}`;
                            alert(details);
                          }}
                          className="text-sm text-[#C4A265] hover:text-[#3E2723] font-medium"
                        >
                          View Details
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="p-12 text-center">
              <p className="text-[#5D4E37]">No orders yet</p>
            </div>
          )}
        </div>

        <div className="mt-4 text-sm text-[#5D4E37]">
          Total Orders: {orders.length}
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminOrders;
